export const DISMISS_COOKIE_PREFIX = 'fw_dismissed_';
export const DISMISS_MINUTES = 60;

export const EXIT_DURATION = 260;

export const PHASES = {
  hidden: 'hidden',
  collapsed: 'collapsed',
  expanded: 'expanded',
  dismissed: 'dismissed',
};

function normalizePath(path) {
  const value = String(path || '').trim();
  if (!value || value === '/') return '/';

  return value.endsWith('/') ? value.slice(0, -1) : value;
}

export function matchesPath(paths, pathname) {
  if (!paths?.length) return false;

  const current = normalizePath(pathname);

  return paths.some((path) => {
    const value = String(path || '').trim();
    if (!value) return false;
    if (value === '*') return true;

    if (value.endsWith('*')) {
      const prefix = normalizePath(value.replace(/\/?\*$/, ''));
      if (prefix === '/') return true;

      return current === prefix || current.startsWith(`${prefix}/`);
    }

    return current === normalizePath(value);
  });
}
